import baseRequest from "../_core/baseRequest";

export default {
    getReportTemplates: reportType =>
        baseRequest.get(`/report-templates?reportType=${reportType}`),
    markReportTemplateAsUsed: id => baseRequest.put(`/report-templates/${id}/mark-used`),
    createReportTemplate: ({reportType, name, filters, selectedColumns}) =>
        baseRequest.post("/report-templates", {
            reportType,
            name,
            filters: filters || {},
            selectedColumns: selectedColumns || [],
        }),
    updateReportTemplate: ({id, name, filters, selectedColumns}) =>
        baseRequest.put(`/report-templates/${id}`, {
            name,
            filters,
            selectedColumns,
        }),
    deleteReportTemplate: id => baseRequest.delete(`/report-templates/${id}`),
};
